import { LineOfCreditDetailsResult } from '@varo/graphql-schema-types';
import GetLineOfCreditAutoPayStatus from 'services/graphql/queries/GetLineOfCreditAutoPayStatus';
import { CombinedError, useQuery } from 'urql';

export interface GetLineOfCreditAutoPayStatusResult {
  getLineOfCreditDetailsResult: LineOfCreditDetailsResult;
  isAutopayEnabled: boolean;
  error?: CombinedError;
  fetching: boolean;
  refetchCheck: () => void;
}

const useGetLineOfCreditAutoPayStatus = () => {
  const [response, refetch] = useQuery<GetLineOfCreditAutoPayStatusResult>({
    query: GetLineOfCreditAutoPayStatus,
    requestPolicy: 'network-only',
  });

  const { data, fetching, error } = response;

  const isAutopayEnabled = data?.getLineOfCreditDetailsResult?.isAutopayEnabled;

  return {
    getLineOfCreditDetailsResult: data,
    isAutopayEnabled,
    fetching,
    error,
    refetch,
  };
};

export default useGetLineOfCreditAutoPayStatus;
